import { render, staticRenderFns } from "./NoticeIcon.vue?vue&type=template&id=5eb85eb6&scoped=true&"
import script from "./NoticeIcon.vue?vue&type=script&lang=js&"
export * from "./NoticeIcon.vue?vue&type=script&lang=js&"
import style0 from "./NoticeIcon.vue?vue&type=style&index=0&id=5eb85eb6&prod&lang=css&"
import style1 from "./NoticeIcon.vue?vue&type=style&index=1&id=5eb85eb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb85eb6",
  null
  
)

export default component.exports